(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["umx-cart"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* ---- Recommendations ---- */
  var recTrack = document.getElementById('umx-cart-recs-track');
  var recSection = document.getElementById('umx-cart-recs');

  function formatPrice(cents) {
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  }

  function addToCart(btn) {
    btn.textContent = '追加中…';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(btn.dataset.variant, 10), quantity: 1 })
    }).then(function(r) {
      if (!r.ok) throw new Error();
      btn.textContent = '追加しました ✓';
      btn.classList.add('umx-cart-rec-card__btn--added');
      setTimeout(function() { window.location.reload(); }, 900);
    }).catch(function() {
      btn.textContent = 'カートに追加';
      btn.disabled = false;
    });
  }

  function buildCard(p) {
    var variant = p.variants && p.variants[0];
    if (!variant) return null;
    var card = document.createElement('div');
    card.className = 'umx-cart-rec-card';
    var imgSrc = '';
    if (p.featured_image) {
      var src = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image.src || '');
      imgSrc = src.replace(/\?.*$/, '') + '?width=340&height=340&crop=center';
    }
    card.innerHTML = (imgSrc ? '<a href="/products/' + p.handle + '" class="umx-cart-rec-card__img-wrap" tabindex="-1">'
        + '<img src="' + imgSrc + '" alt="' + p.title.replace(/"/g, '&quot;') + '" class="umx-cart-rec-card__img" width="172" height="172" loading="lazy"></a>' : '')
      + '<div class="umx-cart-rec-card__body">'
      + '<a href="/products/' + p.handle + '" class="umx-cart-rec-card__title">' + p.title + '</a>'
      + '<span class="umx-cart-rec-card__price">' + formatPrice(p.price_min) + '</span>'
      + '<button class="umx-cart-rec-card__btn" data-variant="' + variant.id + '">カートに追加</button>'
      + '</div>';
    card.querySelector('.umx-cart-rec-card__btn').addEventListener('click', function(e) { addToCart(e.currentTarget); });
    return card;
  }

  function renderRecs(products) {
    if (!recTrack) return;
    products.forEach(function(p) { var c = buildCard(p); if (c) recTrack.appendChild(c); });
  }

  function loadFallback(excludeIds) {
    fetch('/collections/all/products.json?limit=10&sort_by=best-selling')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = (data.products || []).filter(function(p) {
          return excludeIds.indexOf(p.id) === -1;
        }).slice(0, 6);
        if (products.length === 0) { if (recSection) recSection.style.display = 'none'; return; }
        renderRecs(products);
      })
      .catch(function() { if (recSection) recSection.style.display = 'none'; });
  }

  if (recTrack) {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var cartIds = (cart.items || []).map(function(i) { return i.product_id; });
        if (cartIds.length === 0) { loadFallback([]); return; }
        return fetch('/recommendations/products.json?product_id=' + cartIds[0] + '&limit=8&intent=related')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var products = (data.products || []).filter(function(p) {
              return cartIds.indexOf(p.id) === -1;
            }).slice(0, 6);
            if (products.length === 0) { loadFallback(cartIds); return; }
            renderRecs(products);
          })
          .catch(function() { loadFallback(cartIds); });
      })
      .catch(function() { loadFallback([]); });
  }

  /* ---- Cart qty / remove ---- */
  var form = document.getElementById('umx-cart-form');
  if (!form) return;

  function updateCart(key, qty) {
    var body = {};
    body[key] = qty;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: body })
    }).then(function() { window.location.reload(); });
  }

  form.querySelectorAll('.umx-cart-qty').forEach(function(wrap) {
    var key = wrap.dataset.key;
    var input = wrap.querySelector('.umx-cart-qty__input');
    var minus = wrap.querySelector('.umx-cart-qty__minus');
    var plus  = wrap.querySelector('.umx-cart-qty__plus');

    minus.addEventListener('click', function() {
      var val = parseInt(input.value) - 1;
      if (val < 1) val = 1;
      updateCart(key, val);
    });
    plus.addEventListener('click', function() {
      updateCart(key, parseInt(input.value) + 1);
    });
    input.addEventListener('change', function() {
      var val = parseInt(input.value);
      if (val < 1) val = 1;
      updateCart(key, val);
    });
  });

  form.querySelectorAll('.umx-cart-item__remove').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      var line = parseInt(link.dataset.line);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      }).then(function() { window.location.reload(); });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["umx-featured-products"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.umx-fp__cart-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = form.querySelector('.umx-fp__cart-btn');
      var id = form.querySelector('[name="id"]').value;
      var qty = form.querySelector('[name="quantity"]').value;
      var originalText = btn.textContent;
      btn.textContent = '追加中…';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: id, quantity: parseInt(qty)})
      }).then(function(r) {
        if (r.ok) {
          btn.textContent = '✓ カートに追加しました';
          btn.classList.add('is-added');
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } else {
          btn.textContent = originalText;
          btn.disabled = false;
        }
      }).catch(function() {
        btn.textContent = originalText;
        btn.disabled = false;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["umx-jisei-collection"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.umx-jcol__btn[href^="#"]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        var target = document.getElementById(btn.getAttribute('href').slice(1));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
    document.querySelectorAll('.umx-jcol-grid').forEach(function(section) {
    section.querySelectorAll('.umx-jcol-grid__add-btn[data-variant-id]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var variantId = btn.getAttribute('data-variant-id');
        var original = btn.textContent;
        btn.textContent = '追加中…';
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({id: variantId, quantity: 1})
        })
        .then(function(r) {
          if (r.ok) {
            btn.textContent = '✓ カートに追加しました';
            btn.classList.add('is-added');
            document.dispatchEvent(new CustomEvent('cart:updated'));
          } else {
            btn.textContent = original;
            btn.disabled = false;
          }
        })
        .catch(function() {
          btn.textContent = original;
          btn.disabled = false;
        });
      });
    });
  });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["umx-shoku-catalog"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.shoku-pcard__btn[data-variant-id]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var id = btn.getAttribute('data-variant-id');
      var orig = btn.textContent;
      btn.textContent = '追加中…';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: id, quantity: 1})
      })
      .then(function(r) {
        if (r.ok) {
          btn.textContent = '✓ 追加しました';
          btn.classList.add('is-added');
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } else {
          btn.textContent = orig;
          btn.disabled = false;
        }
      })
      .catch(function() { btn.textContent = orig; btn.disabled = false; });
    });
  });
  document.querySelectorAll('.shoku-cat-index__nav-item[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var id = a.getAttribute('href').slice(1);
      var target = document.getElementById(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({behavior: 'smooth', block: 'start'});
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
